/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import { Paper, Typography } from "@mui/material";
import LinkLegalbird from "@/src/components/legalbird/LinkLegalbird/LinkLegalbird";
import jobStyles from "@/src/components/Jobs/Job/jobStyles";

type SendApplicationProps = {
  to?: string;
};

const SendApplication = ({ to }: SendApplicationProps) => {
  return (
    <Paper sx={(theme) => ({ padding: "1.5rem", backgroundColor: theme.palette.primaryPale })} elevation={0}>
      <Typography component={"p"} variant={"h6"} sx={jobStyles.text}>
        Sende Deine Bewerbungsunterlagen inkl. Angabe des Startdatums und Jahreszielgehalts an {to}
      </Typography>
      <LinkLegalbird to={"mailto:jobs@legalbird.de"}>jobs@legalbird.de</LinkLegalbird>
    </Paper>
  );
};

export default SendApplication;
